import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M7.72 17.7l3.47-1.53.81-.36.81.36 3.47 1.53L12 7.27z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2 4.5 20.29zm8.31-4.12l-.81-.36-.81.36-3.47 1.53L12 7.27l4.28 10.43-3.47-1.53z"
})), 'NavigationTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NavigationTwoTone.js
// module id = 5005
// module chunks = 2